<template>
    <div :class="theme.list">
        <slot></slot>
    </div>
</template>
<script>
    import theme from './list.scss';

    export default {
        name: 'list',
        props: {
            number: Boolean,
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        data() {
            return {
                index: 1,
            }
        },
        methods: {
            getNextLabel() {
                return this.number ? this.index++ : '•' ;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// List.vue?66e02b4c